// extracted by mini-css-extract-plugin
module.exports = {"selectionActions":"index_selectionActions__ZFSpn","tableContainer":"index_tableContainer__rpZbh"};